import EventEmitter from "eventemitter3";

const eventEmitter = new EventEmitter();

const Emitter = {
    on: (event: Events, fn) => eventEmitter.on(event as any, fn),
    once: (event: Events, fn) => eventEmitter.once(event as any, fn),
    emit: (event: Events, payload: any = null) => eventEmitter.emit(event as any, payload),
    off: (event: Events, fn) => eventEmitter.off(event as any, fn),
};

Object.freeze(Emitter);

export default Emitter;

export enum Events {
    onNewChatReceived,
    onChatMessageReceived,
    onInitData,
    onPreviewMessage,
    onVisitorDataUpdate,
    OnMessageTextInput,
    OnSelectedBotSuggestion,
    OnDestroyRoom,
    onOperatorLogOut,
    onLogOut,
    onNLUResponse,
    ResetUnReadCount,
    onResourceUser,
    UpdateUnReadCount,
    ScrollMainChatToBottom,
    ToggleShowHideComponent,
    ReAttachExistingRooms,
    startOperatorBreak,
    endOperatorBreak,
    onReceivedWebsite,
    onAddNewWebsite,
    onAddExistingWebsite,
    addNewWebsite,
    saveWebsites,
    validateCompanyform,
    handleNewWebsite,
    onReceivedPinValue,
    onCloseRightSideBar,
    onCollapsedSideBar,
    onBreakTitle,
    changelayOutMode,
    navColor,
    userName,
    updateVisitorInfomation,
    toggleCustomizer,
    CloseCustomizer,
    loadPreviousChat,
    scrollToTop,
    updateCannedResponse,
    BreakApplied,
    onNewNotification,
    EmailFormUrl,
    unMountEmailForm,
    onInternetConnectionChange,
    detectBrowser,
    ScrollCurrentChatToBottom,
    changeQCRole,
    onGetUnSentChat,
    getLoadedData,
    showPendingSurvey,
    notificationText,
    ZOOMIN,
    ZOOMOUT,
    refershCanned,
    FocusedOnWebsiteCanned,
    FocusedOnMessageBox,
    FocusedOnPersonalCanned,
    changeRoom,
    removeMarginOfSideBar,
    strophConnectionStatus,
    openContextMenu,
    signalRConnectionStatus,
    voiceNotificationHeading,
    sessionExpired,
    GetCannedMsgs,
    ThroughCannedMessages,
    GetCannedRequest,
    GetCannedMsgsByWebsite,
    setPrevEnteredChatMsg,
    handlingEmpDrftMsg,
    transferChatAcknowledge,
    resetResources,
    persistBPS,
    EnableSessionExpireNotification,
    getSelectedCannedMessage,
    getAllResources,
    throughResourcesData,
    handleResourcesBeforeUnload,
    pushNewResource,
    EditResource,
    FetchPersistableData,
    loadWebsites,
    passDataToChilds,
    requestForWebsiteData,
    dayWiseRecord,
    getSelectedMessage,
    onHidePreviousChatPanel,
    sendqcMessageByCannedKeywords,
    pushURL,
    onSaveLoader,
    DisplayApiResponse,
    onLoggedInChatRecieved,
    pushEchoValueInChatTree,
    currentChatsChecker,
    currentChatsCheckerOutPut,
    PasswordChange,
    monitoringPanelBreakStatus,
    endQCBreak,
    monitoringPanelType,
    openNestedWindow,
    clearSelectedChat,
    removedBuzzFlag,
    loaderDisplay,
    unMountingChatComponent,
    onReceivedBuzzChat,
    LogoutAfterBreakApplied,
    handleZoomInOut,
    resetWebsites,
    displaySurveyButtonRequest,
    route2ndSurvey,
    handleLayout,
    startSurveyTimer,
    onTestingNewChatReceived,
    onTestingMessageReceived,
    OnTestingDestroyRoom,
    CreateNewChat,
    leaveRoom,
    setWebContentLang,
    internetConnectivityNotify,
    MASR_ExportPdf,
    CNDW_ExportPdf,
    MWSL_ExportPdf,
    MCWW_ExportPdf,
    MWCCG_ExportPdf,
    captureScreen,
    closeLoggedInChatWindow,
    resetSignalRConnectionChecker,
    forceFullyChangeLanguage,
    deleteInstagramMessage,
    onSaveRequest,
    onDeleteRequest,
    onSmtpSave,
    onSmtpRefresh,
    onSmtpUpdate,
    selectedRow,
    toastNotify,
    ClientInvolve,
    clearSugestions,
    get_ISPY_Response,
    clear_ISPY_Response,

    //...................Bot generator section
    reloadBotsDetails,
    DisplayApiErrorResponse,
    GET_EXAMPLES,
    refreshSelectedNode,
    reloadBots,
    toggleSidebarMenu,
    persistMenuBar,
    ServerError,
    refreshIntent,
    changeEntity,
    handleSelectRow,
    getEntities,
    getIntents,
    SelectFirstEntity,
    get_MasterQcChats,
    onLatestMessage,
    ClearChats,
    videoCallResponse,
    startVideoCall,
    videoCallPing,
    endVideoCall,
    videoStatus,
    videoCallEndedInfo,
    clearVideoDetails,
    preventCall,
    hideAndShowVideoCall,
    hideAndShowVideoSection,
    setVideoCallInfo,
    removeVideoCallInfo,
    passDatatoTableComponent,
    passDatatoDetailComponent,
    showSkeleton,
    clearInventoryInfo,
    refreshStats,
    reLogin,
    refreshUserData,
    saveFlowEvent,
    setLoader,
    PopUpPermission,
    messageAcknowledged,
    chatInviteLog,
    DNDClosedChat,
    handleSaveResponse,
    handleErrorResponse,
    goToNextStep,
    checkSingleNodeFlow,
}
